import { makeStyles, Theme } from "@material-ui/core";
import React from "react";
import { DomainInfoDisplay } from "../components/DomainInfoDisplay";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "calc(var(--vh, 1vh) * 100)",
    display: "flex",
    flexDirection: "column",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  textDiv: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  textCenter: {
    textAlign: "center"
  },
  marginB2: {
    marginBottom: theme.spacing(2),
  },
  link: {
    cursor: "pointer",
    color: "#2EA8E5",
    "&:hover, &:active": {
      color: "#0095E0",
    },
  },
  vcenter: {
    display: "flex",
    alignItems: "center",
  },
  domainInfoContainer: {
    position: "fixed",
    bottom: "10px",
    right: "10px",
    maxWidth: "300px",
    zIndex: 1000,
  },
}));

export const E404Screen = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.root}>      
        <div className={classes.body}>
          <div className={classes.textDiv}>
            <h1 className={classes.marginB2}>
              <span>404: Page not found</span>
            </h1>
            <div className={classes.textCenter}>
              <span>Check the web address_</span>
              <span
                className={classes.link}
                onClick={() => window.location.replace("https://blackvue.com/")}
              >
                {"home page"}
              </span>
              {"."}
            </div>
          </div>
        </div>
      </div>
      
      {/* 개발 환경에서만 도메인 정보 표시 */}
      {process.env.NODE_ENV === 'development' && (
        <div className={classes.domainInfoContainer}>
          <DomainInfoDisplay showDetails={true} />
        </div>
      )}
    </React.Fragment>
  );
};
